import ScratchService from './ScratchService';
import config from '../../config';

export default new ScratchService(
    config.scratchHost
);